import { fetchAutocompleteResults } from 'app/providers';
import { optionsSelector } from 'app/store/selectors';
import { retry, select, race, call, delay, put } from 'redux-saga/effects';
import { reportAutocompleteError } from 'app/store/actions/location';
import { ERROR_AUTOCOMPLETE } from 'app/models/Error';

function* fetchRequestTimeout(requestArgs, direction) {
    try {
        // start a race between the searchResultsRequest and a timeout and see what wins
        const winner = yield race({
            autocompleteRequest: call(fetchAutocompleteResults, requestArgs),
            timeout: delay(5000),
        });

        // request successful
        if (winner.autocompleteRequest) {
            return winner.autocompleteRequest;
        }

        // request timed out
        yield put(reportAutocompleteError(ERROR_AUTOCOMPLETE, 'Request timed out.', direction));
        throw new Error('timeout');
    } catch (error) {
        yield put(reportAutocompleteError(ERROR_AUTOCOMPLETE, 'Failed to fetch results.', direction));
        throw new Error(error);
    }
}

export function* requestAutocomplete({ query, departureCity, direction }) {
    const { autocompleteUrl, locale, flixbusCitiesOnly } = yield select(optionsSelector);

    const delayBetweenRetries = 1000;
    const requestArgs = {
        autocompleteUrl,
        query: encodeURIComponent(query),
        locale,
        flixbusCitiesOnly,
        departureCity,
    };

    return yield retry(3, delayBetweenRetries, fetchRequestTimeout, requestArgs, direction);
}
